const app = {
  namespaced: true,

  state: {
    loading: false,
    dialog: '',
    leftBar: true,
    menuActive: '',
    //preventivi
    pagePreve: '',
    numPreve: 0,
    filtroGiorni: 30,
    refreshDati: false,
  },

  mutations: {

    SET_LOADING: (state, vis) => {
      state.loading = vis
    },

    SET_DIALOG: (state, data) => {
      state.dialog = data
    },

    SET_LEFTBAR: (state, data) => {
      state.leftBar = data
    },

    SET_MENUACTIVE: (state, data) => {
      state.menuActive = data
    },

    SET_PAGEPREVE: (state, data) => {
      state.pagePreve = data
    },

    SET_NUMPREVE: (state, data) => {
      state.numPreve = data
    },

    SET_FILTROGIORNI: (state, data) => {
      state.filtroGiorni = data
    },

    SET_REFRESHDATI: (state, data) => {
      state.refreshDati = data;
    }

  },

  getters: {
    getDialog: state => tipo => {
      return state.dialog == tipo
    },

    getLeftBar: state => {
      return state.leftBar
    },

    getMenuActive: state => {
      return state.menuActive
    },

    getPagePreve: state => {
      return state.pagePreve
    },

    getNumPreve: state => {
      return state.numPreve
    },

    getFiltroGiorni: state => {
      return state.filtroGiorni
    },

    getRefreshDati: state => {
      return state.refreshDati
    }
  }


}

export default app
